import { DARWIN_EXPERIMENT_NAMES } from 'shared/enums/darwinExperimentNames';
import { FeatureFlags } from 'featureFlags/constants';
import { MOBILE_WEB_PDP_EXPERIMENT } from 'productTemplate/enums/newMobileWebPdp';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import LocalStorage from 'caches/utils/localStorage';

export const getExperimentGroup = (): string | null => {
  try {
    return LocalStorage.getItem(`${DARWIN_EXPERIMENT_NAMES.MOBILE_WEB_PDP_EXPERIMENT}`);
  } catch {
    return null;
  }
};

export const setExperimentGroup = (group: string) => {
  return LocalStorage.setItem(`${DARWIN_EXPERIMENT_NAMES.MOBILE_WEB_PDP_EXPERIMENT}`, group);
};

export const useIsNewMobilePdpAccessible = () => {
  const { isMobile } = useWindowSize();
  const isNewMobileWebPdpEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ENABLE_NEW_MOBILE_WEB_PDP);
  const circumventABTesting = useFeatureFlag(FeatureFlags.WEB_CIRCUMVENT_DARWIN);
  const experimentGroup = getExperimentGroup();
  const isMobileWebPdpExperimentEnabledForDevice =
    experimentGroup === MOBILE_WEB_PDP_EXPERIMENT.TEST;

  const canAccessNewMobilePdp =
    isMobile &&
    (circumventABTesting || (isNewMobileWebPdpEnabled && isMobileWebPdpExperimentEnabledForDevice));
  return canAccessNewMobilePdp;
};
